import React from 'react';
import { fetchWrapper } from '../../APIManager';
const UserStateContext = /*#__PURE__*/React.createContext();
const UserDispatchContext = /*#__PURE__*/React.createContext();
const initialState = {
  users: []
};

/** REDUCER **/
function UserReducer(state, action) {
  switch (action.type) {
    case 'SET_USERS':
      return {
        ...state,
        users: action.payload
      };
    case 'ADD_USER':
      // check race condition
      const alreadyPresent = state.users.map(u => u.username).includes(action.payload.username);
      return {
        ...state,
        ...(!alreadyPresent && {
          users: [...state.users, action.payload]
        })
      };
    case 'GET_INITIAL':
      {
        return initialState;
      }
    default:
      {
        throw new Error('Unhandled action type caught');
      }
  }
}

/** PROVIDER **/
function UserProvider({
  value,
  children
}) {
  const [state, dispatch] = React.useReducer(UserReducer, initialState);
  return /*#__PURE__*/React.createElement(UserStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(UserDispatchContext.Provider, {
    value: dispatch
  }, children));
}

/** STATE/DISPATCH HOOKS **/
function useUserState() {
  const context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error('useUserState must be used within a UserProvider');
  }
  return context;
}
function useUserDispatch() {
  const context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error('useUserDispatch must be used within a UserProvider');
  }
  return context;
}

/** API **/
const userAPI = {
  getUser: async (url, authUserName, apiKey) => {
    try {
      const slug = `/u/${authUserName}.json`;
      const response = await fetchWrapper(url, slug, apiKey);
      if (!response) {
        throw new Error('Could not get user.');
      }
      return response;
    } catch (err) {
      return {};
    }
  },
  putUser: async (url, authUserName, data, api_key) => {
    try {
      const slug = `/u/${authUserName}.json`;
      const response = await fetchWrapper(url, slug, api_key, 'PUT', data);
      if (!response || response.success !== 'OK') {
        throw new Error('Error occurred while updating user.');
      }
      return response;
    } catch (err) {
      return {};
    }
  },
  getUserUnsubscribe: async (url, unsubscribeKey, apiKey) => {
    try {
      const slug = `/email/unsubscribe/${unsubscribeKey}`;
      const response = await fetchWrapper(url, slug, apiKey);
      if (!response) {
        throw new Error('Could not get user unsubscribe options.');
      }
      return response;
    } catch (err) {
      return {};
    }
  },
  postUserUnsubscribe: async (url, unsubscribeKey, data, apiKey) => {
    try {
      const slug = `/email/unsubscribe/${unsubscribeKey}`;
      const response = await fetchWrapper(url, slug, apiKey, 'POST', {
        ...data,
        override_redirect: true
      });
      if (!response || !['OK', true].includes(response.success)) {
        throw new Error('Error occurred while updating status.');
      }
      return response;
    } catch (err) {
      return {};
    }
  }
};
export { UserProvider, useUserState, useUserDispatch, userAPI };
//# sourceMappingURL=index.js.map